
  <template>
    <div>
      <h1>PRONE LLM 공지사항</h1>
      <GenericBoard :headers="headers" :items="noticeItems" :column-widths="['20%', '60%', '20%']" :items-per-page="10" />
    </div>
  </template>
  
  <script>
  import GenericBoard from '@/components/GenericBoard.vue'
  
  export default {
    components: {
      GenericBoard
    },
    data() {
      return {
        headers: ['일자', '내용', '작성자'],
        noticeItems: [
          {
            date: '2024-06-10',
            content: '최초 공지사항 테스트 ',
            writer: '유국현'
          },
          
        ] 
      }
    },
    
  }
  </script>
  